export const CALENDAR_ICON = 0x0001F4C5;
export const CLOCK_ICON = 0x0001F551;
